import createClient from "openapi-fetch";
import type { components } from "./schema";

/**
 * Typed client for the calls that are not plain CRUD resources (login, the Instagram media feed).
 * Refine's data provider handles the CRUD ones.
 *
 * No base URL: the SPA is served from the backend in production, and Vite proxies /api in
 * development, so requests are always same-origin and the auth cookie rides along automatically.
 */
export const api = createClient<paths>();

export type paths = import("./schema").paths;

// Aliases so pages never reach into the generated file's nested shapes.
export type TrackedPost = components["schemas"]["TrackedPostResponse"];
export type Trigger = components["schemas"]["TriggerResponse"];
export type ProcessedComment = components["schemas"]["ProcessedCommentResponse"];
export type MediaFeedItem = components["schemas"]["MediaFeedItem"];
export type MediaFeedResponse = components["schemas"]["MediaFeedResponse"];
export type Stats = components["schemas"]["StatsResponse"];
export type KeywordMatchMode = components["schemas"]["KeywordMatchMode"];
export type PrivateReplyStatus = components["schemas"]["PrivateReplyStatus"];
export type InstagramAccount = components["schemas"]["InstagramAccountResponse"];
